export enum GaugeLayout {
	CHART = 'layout-chart',
	HORIZONTAL = 'layout-horizontal',
	TWO_COLUMNS = 'layout-two-columns',
	TWO_LINES = 'layout-two-lines',
	VERTICAL = 'layout-vertical'
}
